import { gql } from '@apollo/client';

/**
 * ТЗ 0093 — «Настройки → Роботы и расписания» и «Настройки → ИИ».
 *
 * Имена операций намеренно отличаются от полей бэкенда (иначе codegen
 * схлопывает тип результата). Фрагменты подставляются по имени, без `${…}`:
 * документ с интерполяцией codegen молча пропускает.
 */

export const RuntimeSettingsListQuery = gql`
  query RuntimeSettingsList($section: String) {
    runtimeSettings(section: $section) {
      ...RuntimeSettingFields
    }
  }
`;

export const RuntimeSettingSectionsListQuery = gql`
  query RuntimeSettingSectionsList {
    runtimeSettingSections {
      id
      labelRu
      labelPl
    }
  }
`;

export const RuntimeSettingHistoryQuery = gql`
  query RuntimeSettingHistory($key: String, $limit: Int) {
    runtimeSettingChanges(key: $key, limit: $limit) {
      id
      key
      old
      new
      reason
      userName
      createdAt
    }
  }
`;

export const ScheduledTasksListQuery = gql`
  query ScheduledTasksList {
    scheduledTasks {
      entries {
        name
        task
        domain
        schedule
        keys
        offKeys
        keyStates {
          key
          on
          source
        }
        effectiveOn
        alwaysOn
        periodicTaskEnabled
        lastRunAt
        totalRunCount
        lastSkippedAt
        lastJournalRun {
          ...ScheduledRunFields
        }
      }
      orphans {
        name
        task
        enabled
        schedule
        lastRunAt
        totalRunCount
      }
    }
  }
`;
